import { apiClient } from "features/shared/api/axiosInstance";
import type { PaginatedProgramsDto } from "common/models/api/models/PaginatedProgramsDto";
import type { ProgramDto } from "common/models/api/models/ProgramDto";
import type { ProgramKpisDto } from "common/models/api/models/ProgramKpisDto";
import type { CreateProgramRequest } from "common/models/api/models/CreateProgramRequest";
import type { UpdateProgramRequest } from "common/models/api/models/UpdateProgramRequest";
import type { UpdateProgramAdminRequest } from "common/models/api/models/UpdateProgramAdminRequest";

export const programsApi = {
    kpis: () => apiClient.get<ProgramKpisDto>("/api/programs/kpis"),

    findAll: (params: {
        page?: number;
        pageSize?: number;
        query?: string;
        order?: "ASC" | "DESC";
        orderBy?: string;
        organizationAddress?: string;
        archived?: boolean;
    }) => apiClient.get<PaginatedProgramsDto>("/api/programs", { params }),

    findByAddress: (address: string) => apiClient.get<ProgramDto>(`/api/programs/${address}`),

    create: (body: CreateProgramRequest) => apiClient.post<ProgramDto>("/api/programs", body),

    updateProgram: (address: string, body: UpdateProgramRequest) => apiClient.put<ProgramDto>(`/api/programs/${address}`, body),

    updateProgramAdmin: (address: string, body: UpdateProgramAdminRequest) => apiClient.put(`/api/programs/${address}/admin`, body),

    getBalance: (address: string) => apiClient.get<string>(`/api/programs/${address}/balance`),

    archiveProgram: (address: string) => apiClient.put(`/api/programs/${address}/archive`),

    export: (params?: { query?: string; order?: "ASC" | "DESC"; orderBy?: string; archived?: boolean }) =>
        apiClient.get<string>("/api/programs/export", { params }),
};
